import './previewOfferPage.scss';

import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import { toNumberString } from '@thesavingsgroup/utils/toNumberString';
import { ReactNode, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import vehicleSUVSideView from '../../../assets/vehicle-suv-sideview-two.png';
import { Button } from '../../../components/Button/Button';
import { Header } from '../../../components/Header/Header';
import { LanderImage } from '../../../components/LanderImage/LanderImage';
import { Rate } from '../../../components/Rate/Rate';
import useParameterStore from '../../../store/parameterStore/useParameterStore';
import usePreviewStore from '../../../store/previewStore/usePreviewStore';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const {
    computed: { hasValidPreviewOffer, titleText },
  } = usePreviewStore();

  const { amount, apr, payment, term } = useParameterStore();

  const { handleSubmit } = useForm();

  const formSubmit = (): void => {
    navigate('/preview/activation');
  };

  useEffect((): void => {
    if (!hasValidPreviewOffer) {
      navigate('/sign-up');
    }
  }, [hasValidPreviewOffer]);

  return (
    <div className="preview-offer-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <Header showLogo splitLayout />

          <main>
            <LanderImage
              alt={t('imageAlts.vehicleSUVSideView')}
              defaultImage={vehicleSUVSideView}
            />
            <form
              data-testid={locator.pages.previewOffer.form.root}
              noValidate
              onSubmit={handleSubmit(formSubmit)}
            >
              <div className="form-content">
                <h1 data-testid={locator.pages.previewOffer.form.h1}>
                  {titleText}
                </h1>
                <h2 data-testid={locator.pages.previewOffer.form.h2}>
                  {t('PreviewOfferPage.subtitle', {
                    amount: toNumberString(amount),
                  })}
                </h2>

                <div style={{ marginBottom: '4.5rem' }}>
                  <Rate
                    apr={apr}
                    monthlyPaymentAmount={payment}
                    term={term}
                    isEstimate
                  />
                </div>

                <Button
                  data-testid={locator.pages.previewOffer.form.submitButton}
                  fullWidth
                  submit
                >
                  {t('PreviewOfferPage.continue')}
                </Button>

                <p className="form-disclaimer">
                  {t('PreviewOfferPage.disclaimer')}
                </p>
              </div>
              <footer data-testid={locator.pages.previewOffer.footer.root}>
                {t('copyright', { year: new Date().getFullYear() })}
              </footer>
            </form>
          </main>
        </Box>
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'PreviewOfferPage';
